module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_25.052e1177.png";